/* eslint-disable */
import React, { useState } from 'react'
import { Input, Card, Tag, Spin, Empty, Checkbox, message } from 'antd'
import { CalendarOutlined, SearchOutlined } from '@ant-design/icons'
import moment from 'moment'
import Layout from '../Home'
import { getUserInfoByCid, getAppointmentsByPatientId } from '../../apiServices/patientLabDebugServices'

const GREEN = '#0A905F'
const POSTPONED = 'เลื่อนนัด' // oappstName value the mobile app styles red/grey

// Map raw HIE appointment docs, sorted ascending by date (same as mobile
// AppointmentList/hooks.js). Future-only filtering is applied at render time.
const processAppointments = (docs) => {
  if (!Array.isArray(docs)) {
    return []
  }
  return docs
    .filter((a) => a && a.appointmentDateTime)
    .map((a) => ({
      appointmentDateTime: a.appointmentDateTime,
      clinicName: a.clinicName || '-',
      doctorName: a.doctorName || 'ไม่ระบุแพทย์',
      note: a.note || '',
      status: a.oappstName || '',
      isPostponed: a.oappstName === POSTPONED,
      hn: a.hn,
    }))
    .sort((a, b) => new Date(a.appointmentDateTime) - new Date(b.appointmentDateTime))
}

const formatDateTime = (value) => {
  if (!value) {
    return ''
  }
  const m = moment(value)
  if (!m.isValid()) {
    return String(value)
  }
  return `${m.format('D MMM YYYY')} (${m.format('HH:mm')} น.)`
}

function Content() {
  const [cidInput, setCidInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [patient, setPatient] = useState(null)
  const [appointments, setAppointments] = useState(null)
  const [showAll, setShowAll] = useState(false)

  const onSearch = async () => {
    const cId = String(cidInput || '').trim()
    if (!cId) {
      message.warning('กรุณากรอก cId ของคนไข้')
      return
    }
    setLoading(true)
    setPatient(null)
    setAppointments(null)
    try {
      const infos = await getUserInfoByCid(cId)
      const info = Array.isArray(infos) ? infos[0] : null
      if (!info || !info.userId) {
        message.error('ไม่พบคนไข้ที่มี cId นี้')
        setLoading(false)
        return
      }
      const name = [info.firstName, info.lastName].filter(Boolean).join(' ')
      setPatient({ cId: info.cId, userId: info.userId, name })

      const data = await getAppointmentsByPatientId(info.userId, 1, 40)
      const docs = data && Array.isArray(data.docs) ? data.docs : []
      setAppointments(processAppointments(docs))
    } catch (e) {
      message.error('เกิดข้อผิดพลาดในการดึงข้อมูล')
    } finally {
      setLoading(false)
    }
  }

  const renderList = () => {
    if (!appointments) {
      return null
    }
    const list = showAll
      ? appointments
      : appointments.filter((a) => moment(a.appointmentDateTime).isAfter(moment()))

    if (list.length === 0) {
      return (
        <Empty
          description={
            showAll ? 'ไม่พบรายการนัดหมาย' : 'ไม่มีนัดหมายที่ยังไม่ถึง (ลองติ๊ก "แสดงทั้งหมด")'
          }
        />
      )
    }

    return list.map((appt, index) => (
      <Card
        key={index}
        style={{
          marginBottom: 12,
          background: appt.isPostponed ? '#f2f2f2' : '#fff',
        }}
      >
        <div style={{ color: appt.isPostponed ? '#F44336' : GREEN, fontWeight: 'bold', marginBottom: 4 }}>
          {formatDateTime(appt.appointmentDateTime)}
        </div>
        <div style={{ fontSize: 16, fontWeight: 'bold', color: '#095C3E' }}>{appt.clinicName}</div>
        {appt.note ? <div style={{ color: '#555', marginTop: 4 }}>รายละเอียด: {appt.note}</div> : null}
        <div style={{ color: '#555', marginTop: 4 }}>แพทย์: {appt.doctorName}</div>
        {appt.hn ? <div style={{ color: '#999', marginTop: 4 }}>HN: {appt.hn}</div> : null}
        {appt.status ? (
          <div style={{ marginTop: 8 }}>
            <Tag color={appt.isPostponed ? 'red' : 'green'}>{appt.status}</Tag>
          </div>
        ) : null}
      </Card>
    ))
  }

  return (
    <div style={{ padding: 24, maxWidth: 820, margin: '0 auto', width: '100%' }}>
      <h1 style={{ color: GREEN, marginBottom: 2 }}>รายการนัดหมายแพทย์ที่โรงพยาบาล (debug)</h1>
      <div style={{ color: '#888', marginBottom: 16 }}>
        กรอก cId ของคนไข้เพื่อดึงรายการนัดหมายที่โรงพยาบาลแบบเดียวกับฝั่งมือถือ
      </div>

      <Input.Search
        placeholder="cId ของคนไข้ (เช่น 3101501761939)"
        enterButton={<span><SearchOutlined /> ค้นหา</span>}
        size="large"
        value={cidInput}
        onChange={(e) => setCidInput(e.target.value)}
        onSearch={onSearch}
        style={{ marginBottom: 12 }}
      />

      {patient ? (
        <div style={{ background: '#EAF7F1', padding: '8px 12px', borderRadius: 6, marginBottom: 12 }}>
          คนไข้: {patient.name || '-'} | cId: {patient.cId} | userId: {patient.userId}
        </div>
      ) : null}

      {appointments ? (
        <div style={{ marginBottom: 12 }}>
          <Checkbox checked={showAll} onChange={(e) => setShowAll(e.target.checked)}>
            แสดงทั้งหมด (รวมที่ผ่านมาแล้ว) — ค่าเริ่มต้นแสดงเฉพาะที่ยังไม่ถึงเหมือนมือถือ
          </Checkbox>
        </div>
      ) : null}

      <Spin spinning={loading}>{renderList()}</Spin>
    </div>
  )
}

function PatientAppointmentLookup(props) {
  return <Layout {...props} render={() => <Content />} />
}

export default PatientAppointmentLookup
